import { OrderFieldsFragment } from '../../graphql';
import { formatTimePlaced } from '../../utils/formatTimePlaced';
import { getPrettyPickupLocation } from '../../utils/getPrettyPickupLocation';
import { Row } from './Row';
import { useRecoilValue } from 'recoil';
import { storeState } from '../../../Store/atoms';
import React from 'react';

export type DetailsProps = React.HTMLAttributes<HTMLDivElement> &
	Pick<
		OrderFieldsFragment,
		| 'pickupName'
		| 'pickupLocation'
		| 'timePlaced'
		| 'id'
		| 'status'
		| 'storeId'
	>;

export const Details: React.FC<DetailsProps> = ({
	pickupName,
	pickupLocation,
	timePlaced,
	id,
	status,
	className,
	storeId,
	...props
}) => {
	const store = useRecoilValue(storeState);
	const prettyPickupLocation = getPrettyPickupLocation(pickupLocation);
	const locationAddress = store?.address1;
	const locationLat = store?.latitude;
	const locationLong = store?.longitude;

	return (
		<div
			className={`order-details${className ? ` ${className}` : ''}`}
			{...props}
		>
			<Row pt={0} left="Name:" right={pickupName} />
			{status.status === 'ORDER_REFUND_PROCESSED' ? (
				<Row left="Order Status:" right={'Refunded'} />
			) : (
				<>
					<Row left="Pickup:" right={prettyPickupLocation} />
					<Row
						left="Placed at: "
						right={formatTimePlaced(timePlaced)}
					/>
				</>
			)}
			<Row pb={0} left="Order ID:" right={id} />
			<Row
				pb={0}
				left="Location:"
				right={
					<a
						href={
							'https://www.google.com/maps/search/?api=1&query=' +
							locationLat +
							'%2C' +
							locationLong
						}
						target="_blank"
						rel="noreferrer"
					>
						{locationAddress}
					</a>
				}
			/>
			<Row
				pb={0}
				left="Location Phone:"
				right={<a href={'tel:+1' + store?.phone}>{store?.phone}</a>}
			/>
		</div>
	);
};
